import arcTitan from "./arcTitan";

export default {
  arcTitan,
};
